import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ClientReferenceType,
  GiftCardInterface,
  PastFormInterface,
  RecentServiceInterface,
  RequiredFormInterface,
  SiteAlertsInterface,
  UpcomingServiceInterface
} from 'types';

export type ClientStore = {
  isLoading: boolean;
  isServiceHistoryLoading: boolean;
  isRequiredFormsLoading: boolean;
  isSignedFormsLoading: boolean;
  errorMsg: string;
  upcomingServices: UpcomingServiceInterface[];
  recentServices: RecentServiceInterface[] | null;
  giftCards: GiftCardInterface[];
  requiredForms: RequiredFormInterface[] | null;
  signedForms: PastFormInterface[] | null;
  isMembershipModalOpen: boolean;
  siteAlerts: SiteAlertsInterface[];
  referenceData: ClientReferenceType | null;
};

const initialState: ClientStore = {
  errorMsg: '',
  isLoading: false,
  isServiceHistoryLoading: false,
  isRequiredFormsLoading: false,
  isSignedFormsLoading: false,
  upcomingServices: [],
  recentServices: null,
  giftCards: [],
  requiredForms: null,
  signedForms: null,
  isMembershipModalOpen: false,
  siteAlerts: [],
  referenceData: null
};

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setIsServiceHistoryLoading: (state, action: PayloadAction<boolean>) => {
      state.isServiceHistoryLoading = action.payload;
    },
    setIsRequiredFormsLoading: (state, action: PayloadAction<boolean>) => {
      state.isRequiredFormsLoading = action.payload;
    },
    setIsSignedFormsLoading: (state, action: PayloadAction<boolean>) => {
      state.isSignedFormsLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setRecentServices: (
      state,
      action: PayloadAction<RecentServiceInterface[]>
    ) => {
      state.recentServices = action.payload;
    },
    setUpcomingServices: (
      state,
      action: PayloadAction<UpcomingServiceInterface[]>
    ) => {
      state.upcomingServices = action.payload;
    },
    setGiftCards: (state, action: PayloadAction<GiftCardInterface[]>) => {
      state.giftCards = action.payload;
    },
    setRequiredForms: (
      state,
      action: PayloadAction<RequiredFormInterface[]>
    ) => {
      state.requiredForms = action.payload;
    },
    setSignedForms: (state, action: PayloadAction<PastFormInterface[]>) => {
      state.signedForms = action.payload;
    },
    setMembershipModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isMembershipModalOpen = action.payload;
    },
    setSiteAlerts: (state, action: PayloadAction<SiteAlertsInterface[]>) => {
      state.siteAlerts = action.payload;
    },
    setReferenceData: (state, action: PayloadAction<ClientReferenceType>) => {
      state.referenceData = action.payload;
    }
  }
});

export const {
  setError,
  setIsLoading,
  setIsServiceHistoryLoading,
  setIsRequiredFormsLoading,
  setIsSignedFormsLoading,
  setUpcomingServices,
  setGiftCards,
  setRequiredForms,
  setSignedForms,
  setRecentServices,
  setMembershipModalOpen,
  setSiteAlerts,
  setReferenceData
} = clientSlice.actions;

export default clientSlice.reducer;
